<lib-base-signal-input
  [label]="label()"
  [showRequired]="showRequiredIndicator()"
  [showError]="showError()"
  [errorMessage]="errorMessage()"
  [disabled]="disabled()"
  [showExternalLabel]="true"
>
  <div input class="w-full">
    @if (helpText()) {
      <p class="mb-3 text-xs text-slate-500">{{ helpText() }}</p>
    }
    <div class="w-full space-y-2 py-1">
      @for (option of options(); track option.value) {
        <button
          type="button"
          class="flex w-full items-center gap-4 rounded-lg border px-3 py-2.5 text-left transition-all duration-150"
          [class.cursor-pointer]="!isInteractionBlocked()"
          [class.cursor-default]="isInteractionBlocked()"
          [disabled]="disabled()"
          [attr.aria-disabled]="isInteractionBlocked() ? true : null"
          [class.border-blue-500]="isSelected(option)"
          [class.bg-blue-50]="isSelected(option)"
          [class.border-gray-300]="!isSelected(option)"
          [class.opacity-60]="disabled()"
          (click)="toggleOption(option)"
        >
          <span
            class="flex h-5 w-5 shrink-0 items-center justify-center rounded border-2"
            [class.border-blue-500]="isSelected(option)"
            [class.bg-blue-500]="isSelected(option)"
            [class.border-gray-400]="!isSelected(option)"
          >
            @if (isSelected(option)) {
              <svg class="h-3 w-3 text-white" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M5 12.5L9.5 17L19 7"
                  stroke="currentColor"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            }
          </span>

          <span class="min-w-0 flex-1">
            <span class="block text-sm font-semibold text-gray-900">
              {{ option.label }}
            </span>
          </span>
        </button>
      }
    </div>
  </div>
</lib-base-signal-input>
